import { useRevenueData } from "./hooks/useRevenueData";
import { useRevenueCalculations } from "./hooks/useRevenueCalculations";
import { MonthlyRevenueChart } from "./components/revenue/MonthlyRevenueChart";
import { ClientRevenueChart } from "./components/revenue/ClientRevenueChart";
import { RevenueStats } from "@/components/shared/revenue/RevenueStats";

interface RevenueAnalyticsProps {
  clients: { id: string; name: string; }[];
}

export const RevenueAnalytics = ({ clients }: RevenueAnalyticsProps) => {
  const { revenueData, isLoading } = useRevenueData();
  const { monthlyRevenueData, clientRevenueData, totalRevenue, averageRevenue } = useRevenueCalculations(revenueData);

  if (isLoading) {
    return <div className="p-8 text-center">Loading revenue analytics...</div>;
  }

  return (
    <div className="space-y-6">
      <RevenueStats 
        totalRevenue={totalRevenue}
        averageRevenue={averageRevenue}
        totalClients={clients.length}
        showAverage={true}
        showClients={true}
      />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <MonthlyRevenueChart data={monthlyRevenueData} />
        <ClientRevenueChart data={clientRevenueData} />
      </div>
    </div>
  );
};
